/**
 *   Generated file. Do not edit
 */
import './converter-stream-extension';

import { BodyConverter } from '@iotize/tap/client/api';

import { DataLogOption } from './models';
import { SinglePacket } from '@iotize/tap/service/impl/single-packet';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

export class DataLogOptionConverter implements BodyConverter<DataLogOption> {
  public encode(
    model: DataLogOption,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeDataLogOption(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): DataLogOption {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readDataLogOption();
  }
}
